import { API_ROOT, dispatchGetJSONAsync, completeJSONAsync } from './BaseApi';
import appdata from '../Services/appdata';

const ApiDebtors = () => {
  const getSummary = async ({ selectedYears, defaultYear, defaultMonth }) => {
    let queryParams = '';
    const company_id = appdata.getItem('company').id;
    const company_org_id = appdata.getItem('company_org_id');

    let _selectedYears = selectedYears.slice();
    const allIndex = _selectedYears.indexOf('All');
    if (allIndex > -1) _selectedYears.splice(allIndex, 1);
    const filter = { years: _selectedYears };

    queryParams +=
      '?filter=' +
      JSON.stringify(filter) +
      '&dyear=' +
      defaultYear +
      '&dmonth=' +
      defaultMonth;

    let task = await dispatchGetJSONAsync(
      `${API_ROOT}/debtors/${company_id}/${company_org_id}/summary${queryParams}`,
    );
    if (!task) {
      return [];
    }
    return await completeJSONAsync(task);
  };

  const getDetail = async ({ selectedYears, defaultYear, defaultMonth }) => {
    let queryParams = '';
    const company_id = appdata.getItem('company').id;
    const company_org_id = appdata.getItem('company_org_id');

    let _selectedYears = selectedYears.slice();
    const allIndex = _selectedYears.indexOf('All');
    if (allIndex > -1) _selectedYears.splice(allIndex, 1);
    let filter = { years: _selectedYears };

    queryParams +=
      '?filter=' +
      JSON.stringify(filter) +
      '&dyear=' +
      defaultYear +
      '&dmonth=' +
      defaultMonth;

    let task = await dispatchGetJSONAsync(
      `${API_ROOT}/debtors/${company_id}/${company_org_id}/detail${queryParams}`,
    );
    if (!task) {
      return [];
    }
    return await completeJSONAsync(task);
  };

  return {
    getSummary,
    getDetail,
  };
};

export default ApiDebtors();
